module.exports = "../../static/fonts/Roboto-Regular.3e5675c.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/Roboto-Regular.woff
// module id = 485
// module chunks = 0